export class CreationErrorController {
    static $inject = ['DEFAULT_PORTAL_URL', 'LoadingService', 'TenantService'];
    constructor(DEFAULT_PORTAL_URL, LoadingService, TenantService) {
        this.DEFAULT_PORTAL_URL = DEFAULT_PORTAL_URL;
        this.LoadingService = LoadingService;
        this.TenantService = TenantService;
        this.LoadingService.stopLoading();
        this.blipDomain = this.DEFAULT_PORTAL_URL;
        this.pureDomain = this.TenantService.getDefaultPortalUrl(false);
    }
}
CreationErrorController.$inject = ['DEFAULT_PORTAL_URL', 'LoadingService', 'TenantService'];
